const dashboardRouteList = {
     dashboard:"",
     receptionpatient: "reception-patient",
     reception:"reception",
     angular:"angular",
     patientWallet:"patient-Wallet",
     patients:"patients",
     Radiology:"Radiology",
     lab:'lab',
}

export default dashboardRouteList